import styles from './GridMemo.module.scss'
import { Grid, Icon } from 'semantic-ui-react'

interface GridMemoProps {
  icon: JSX.Element
  content: string
}

export const GridMemo = ({ icon, content }: GridMemoProps): JSX.Element => (
  <div className={styles.gridMemoCard + ' buildingBlock'}>
    <Grid verticalAlign="middle">
      <Grid.Row>
        <Grid.Column width={3}>
          <Icon.Group>
            <Icon name="circle thin" className={styles.circleIcon} />
            <div className={styles.iconContainer}>
              <div className={styles.icon}>{icon}</div>
            </div>
          </Icon.Group>
        </Grid.Column>
        <Grid.Column width={13}>
          <p>{content}</p>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </div>
)
